import { useLayoutEffect } from 'react';
import useWhiteLabelProject from 'Hook/useEntkhabino';
import reactManifest from 'react-manifest';
import { manifestConfigs } from 'utils/manifestConfigs';

const useManifest = () => {
	const {
		isDarsad,
		isEntekhab,
		isRefahYar,
		isSabahlend,
		isFara,
		isHamtaland,
		isRayansaipa,
		isGhestane,
		isDemo,
		isHastesh,
		isTisa,
		isSaana,
		isShopp,
		isArbaeen,
		isArmanPay,
		isLendavid,
		isFlyToday,
		isCalko,
		isCan,
		isDanesh,
		isKarma,
	} = useWhiteLabelProject();

	useLayoutEffect(() => {
		const getActiveManifest = () => {
			if (isSabahlend) return manifestConfigs.sabalend;
			if (isDarsad) return manifestConfigs.darsad;
			if (isEntekhab) return manifestConfigs.entekhab;
			if (isRefahYar) return manifestConfigs.refahyar;
			if (isFara) return manifestConfigs.fara;
			if (isHamtaland) return manifestConfigs.hamtaland;
			if (isRayansaipa) return manifestConfigs.rayansaipa;
			if (isGhestane) return manifestConfigs.ghestane;
			if (isDemo) return manifestConfigs.demo;
			if (isTisa) return manifestConfigs.tisa;
			if (isSaana) return manifestConfigs.saana;
			if (isShopp) return manifestConfigs.shopp;
			if (isArbaeen) return manifestConfigs.Arbaeen;
			if (isDanesh) return manifestConfigs.danesh;
			if (isHastesh) return manifestConfigs.hastesh;
			if (isArmanPay) return manifestConfigs.armanpay;
			if (isLendavid) return manifestConfigs.lendavid;
			if (isFlyToday) return manifestConfigs.flyToday;
			if (isCalko) return manifestConfigs.calko;
			if (isCan) return manifestConfigs.can;
			if (isKarma) return manifestConfigs.karma;
			return manifestConfigs.keepa;
		};

		reactManifest.update(getActiveManifest(), '#manifest-placeholder');
	});

	return null;
};

export default useManifest;
